import React, { useState, useEffect } from 'react';
import Sidebar from 'react-sidebar';
import SidebarContents from './sideBarContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import Config from '../../config/Config';
import { setInitialMyStepDetails } from '../../redux/mystep/mystep.actions';
import ErrorModal from '../common/errorModal';
import { setUserType } from '../../redux/userAuthentication/userAuth.actions';
import UserTypes from '../../utils/userTypes';

const SidebarMobile = ({
	fullName,
	setInitialMyStepDetails,
	userPic,
	userType,
	setUserType,
}) => {
	// eslint-disable-next-line no-unused-vars
	const [scroll, setScrollState] = useState(false);
	const [sidebarOpen, onSetSidebarOpen] = useState(false);

	const [name, setName] = useState('');

	useEffect(() => {
		document.getElementById('profileHeader');
		setInitialMyStepDetails();
	}, [setInitialMyStepDetails]);

	let details = JSON.parse(localStorage.getItem('userDetails'));

	useEffect(() => {
		setName(details?.full_name || fullName);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [details?.full_name, fullName]);

	return (
		<section>
			<Sidebar
				sidebar={
					<section
						classNames="step-main-nav "
						onClick={() => onSetSidebarOpen(false)}
					>
						<SidebarContents onSetSidebarOpen={onSetSidebarOpen} />
					</section>
				}
				open={sidebarOpen}
				onSetOpen={onSetSidebarOpen}
				styles={{
					sidebar: {
						zIndex: 100000,
						position: 'absolute',
						background: 'white',
						width: '50%',
						top: 0,
						bottom: 0,
						overflowY: 'auto',
					},
					overlay: {
						zIndex: 4,
					},
				}}
			>
				<div className="step-def-header " scroll={scroll}>
					<section className="step-container align-stretch container ">
						{!window.location.pathname.match(/parent|child/g) && (
							<span onClick={() => onSetSidebarOpen(true)}>
								<FontAwesomeIcon icon={faBars} size="lg" />
							</span>
						)}
						<a href="/mycourse" className="logoContainer">
							{' '}
							<img
								className="img-responsive logo logo-responsive-mobile"
								src="https://storage.googleapis.com/assets.thehindustep.in/img/STEPElogo.png"
								alt="logo"
							/>{' '}
						</a>
						<div className="page-right-section">
							<div className="dashboard-page ">
								<div className="db-body ">
									<div id="profileHeader" className="user-header ">
										<div className="user-header-dp ">
											<a href="/profile">
												<img
													src={
														!!userPic ? userPic : `${Config.ASSETSPATH}/img/Proflie_pic.png`
													}
													href="/profile"
													alt="profile"
												/>
											</a>
										</div>
										<div className="user-header-links ">
											<a href="/profile" className="UserNameText">
												Hello, {name}
											</a>
											{userType === UserTypes.Parent && (
												<a
													onClick={() => setUserType(UserTypes.Regular)}
													href="/mycourse"
												>
													My Courses
												</a>
											)}
											<a href="/logout" style={{ cursor: 'pointer' }}>
												<i className="fa fa-sign-out"></i>Logout
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<ErrorModal />
				</div>
			</Sidebar>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { userType } = state.rootReducer.loginDetails;
	return {
		fullName: state.rootReducer.userDetails.full_name,
		o_level: state.rootReducer.myStepDetails.score.oLevel,
		userPic: state.rootReducer.loginDetails.userPic,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setInitialMyStepDetails: () => dispatch(setInitialMyStepDetails()),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMobile);
